module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixturesWrap"
  }, [(!_vm.noDataModeShow) ? _c('p', {
    staticClass: "tableTit clearfix"
  }, [_c('span', {
    staticClass: "first",
    class: {
      'prevBtnhidden': !_vm.prevBtn
    },
    on: {
      "click": _vm.prevFn
    }
  }, [_c('img', {
    staticClass: "leftArrow",
    attrs: {
      "src": require("../assets/stats/arrow_left.png")
    }
  }), _vm._v("Previous\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "second"
  }, [_vm._v(" " + _vm._s(_vm.currentRoundName))]), _vm._v(" "), _c('span', {
    staticClass: "third",
    class: {
      'prevBtnhidden': !_vm.nextBtn
    },
    on: {
      "click": _vm.nextFn
    }
  }, [_vm._v("Next\n            "), _c('img', {
    staticClass: "rightArrow",
    attrs: {
      "src": require("../assets/stats/arrow_right.png")
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tableBody"
  }, [(_vm.noDataMode) ? _c('div', {
    staticClass: "noDataWrap"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/stats/Stats_nulldata.png?v1232")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sorry"
  }, [_vm._v("Sorry , no content yet")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fixturesMatchData), function(item, index) {
    return _c('div', {
      staticClass: "list clearfix"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm.tran12(item.finalIneedTime.finalTime_md_hm)))]), _vm._v(" "), _c('p', {
      staticClass: "teamA clearfix"
    }, [_c('span', {
      staticClass: "teamA_name"
    }, [_vm._v(_vm._s(item.team_A_name))]), _c('img', {
      directives: [{
        name: "team-logo",
        rawName: "v-team-logo"
      }],
      staticClass: "teamA_logo",
      attrs: {
        "src": _vm.getImgSrc(item.team_A_logo)
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "score"
    }, [(item.status === 'Cancelled' || item.status === 'Postponed' || item.status === 'Suspended' || item.status === 'Uncertain') ? _c('span', [_vm._v("--")]) : _vm._e(), _vm._v(" "), (item.status === 'Fixture') ? _c('span', [_vm._v("VS")]) : _vm._e(), _vm._v(" "), (item.status === 'Played' || item.status === 'Playing') ? _c('span', {
      class: {
        'colorGreen': item.status === 'Playing'
      }
    }, [_vm._v("\n                    " + _vm._s(item.fs_A) + " : " + _vm._s(item.fs_B) + "\n                ")]) : _vm._e()]), _vm._v(" "), _c('p', {
      staticClass: "teamB clearfix"
    }, [_c('span', {
      staticClass: "teamB_name"
    }, [_vm._v(_vm._s(item.team_B_name))]), _vm._v(" "), _c('img', {
      directives: [{
        name: "team-logo",
        rawName: "v-team-logo"
      }],
      staticClass: "teamB_logo",
      attrs: {
        "src": _vm.getImgSrc(item.team_B_logo)
      }
    })])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b2a6314","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fixtures.vue
// module id = 676
// module chunks = 3